import React from 'react';
import { Markdown } from './index';
export var JSONSnippet = function (_a) {
    var snippet = _a.snippet;
    if (typeof snippet === 'object') {
        snippet = '```json\n' + JSON.stringify(snippet, undefined, 2) + '\n```';
    }
    return React.createElement(Markdown, null, snippet);
};
//# sourceMappingURL=JSONSnippet.js.map